export default __webpack_public_path__ + "images/subsecretaria-de-derechos-humanos-logo.66ebd194b553191b0ccd9835111bae47.png";